// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c9d1b1df","453":"0a17eafd","455":"d5a6f782"}[chunkId] + ".chunk.js";
};